import React from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import moment from 'moment';
import {
  Heading1, Paragraph, LinkStyled, Spacer,
} from '../components/typography';
import { Container, Row, Col } from '../components/grid';
import { Table, Td } from '../components/tables';
import { MoneyFormat } from '../components/Format';
import SidemenuLayout from '../layout/DefaultLayout/Layouts/SidemenuLayout';

export class Betaling extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      amount: 0,
      txnid: '',
      dateTime: '',
      hasSetProps: false,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.hasSetProps) {
      return {};
    }
    const {
      location: {
        search,
      },
    } = nextProps;
    const args = queryString.parse(search);
    const {
      orderid,
      date,
      time,
      txnid,
      amount,
    } = args;
    return {
      name: orderid,
      amount,
      txnid,
      dateTime: `${moment(date, 'YYYYMMDD').format('DD-MM-YYYY')} ${moment(time, 'HHmm').format('HH:mm')}`,
      hasSetProps: true,
    };
  }

  render() {
    const {
      name,
      amount,
      txnid,
      dateTime,
    } = this.state;
    return (
      <SidemenuLayout menuPicker="Infosider" activeSidemenu="Betal">
        <Container white>
          <Row>
            <Col xs={12} textCenter>
              <Heading1>
                Din betaling er gennemført!
              </Heading1>
              <Table lines1 inlineBlock width="initial">
                <tbody>
                  <tr>
                    <Td textLeft>Dato og tid</Td>
                    <Td textRight>{dateTime}</Td>
                  </tr>
                  <tr>
                    <Td textLeft>Faktura nr.:</Td>
                    <Td textRight>{name}</Td>
                  </tr>
                  <tr>
                    <Td textLeft>Transaktions ID:</Td>
                    <Td textRight>{txnid}</Td>
                  </tr>
                  <tr>
                    <Td textLeft>Beløb:</Td>
                    <Td textRight><MoneyFormat money={amount} moms /></Td>
                  </tr>
                </tbody>
              </Table>
              <Paragraph>
                Hvis du har nogle spørgsmål vedrørende betalingen så kontakt os på tlf. 43 27 00 00.
              </Paragraph>
              <Spacer size="20" />
              <LinkStyled to="/betaling" title="Betal endnu et beløb">
                Tryk her hvis du skal betale endnu et beløb.
              </LinkStyled>
            </Col>
          </Row>
        </Container>
      </SidemenuLayout>
    );
  }
}

export default withRouter(Betaling);
